import { render, staticRenderFns } from "./LuckyDrawContent.vue?vue&type=template&id=3086b923&scoped=true"
import script from "./LuckyDrawContent.vue?vue&type=script&lang=ts"
export * from "./LuckyDrawContent.vue?vue&type=script&lang=ts"
import style0 from "./LuckyDrawContent.vue?vue&type=style&index=0&id=3086b923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3086b923",
  null
  
)

export default component.exports